import Infrastructure from "./InfrastructureRoot.vue"
export default Infrastructure
